export const FILTER_SELECT_CLASS =
  "w-full [&_.ant-select-selector]:!h-9 [&_.ant-select-selector]:!min-h-9 [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!rounded-lg [&_.ant-select-selector]:!border-gray-200 [&_.ant-select-selector]:!bg-[#fafafa] [&_.ant-select-selector]:!px-3 [&_.ant-select-selection-item]:!leading-7 [&_.ant-select-selection-placeholder]:!leading-7";

export interface ChangeRequestFilterValues {
  projectId: string | undefined;
  status: string | undefined;
  raisedToClientStatus: string | undefined;
}

export const EMPTY_CHANGE_REQUEST_FILTERS: ChangeRequestFilterValues = {
  projectId: undefined,
  status: undefined,
  raisedToClientStatus: undefined,
};
